import { render, staticRenderFns } from "./LabelNormal2.vue?vue&type=template&id=68f3ffcb&scoped=true&"
import script from "./LabelNormal2.vue?vue&type=script&lang=js&"
export * from "./LabelNormal2.vue?vue&type=script&lang=js&"
import style0 from "./LabelNormal2.vue?vue&type=style&index=0&id=68f3ffcb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f3ffcb",
  null
  
)

export default component.exports